import { z } from 'zod';
import { LicenseStatus } from '@features/systems/domain/systemLicenses.types';

export const MonthOverMonthMetricSchema = z.object({
  currentMonth: z.number(),
  previousMonth: z.number(),
});

export type MonthOverMonthMetric = z.infer<typeof MonthOverMonthMetricSchema>;

export const AdminMetricsResponseSchema = z.object({
  systemCount: z.number(),
  onlineSystemCount: z.number(),
  systemsMonthOverMonth: MonthOverMonthMetricSchema,
  customerCount: z.number(),
  hardwareUnitCount: z.number(),
  customersMonthOverMonth: MonthOverMonthMetricSchema,
  licenseCount: z.number(),
  activeLicenseCount: z.number(),
  licensesMonthOverMonth: MonthOverMonthMetricSchema,
  packageCount: z.number(),
  activePackageCount: z.number(),
  userCount: z.number(),
  adminCount: z.number(),
  supportCount: z.number(),
  viewerCount: z.number(),
  usersMonthOverMonth: MonthOverMonthMetricSchema,
});

export type AdminMetricsResponse = z.infer<typeof AdminMetricsResponseSchema>;

export const LicenseViewerRowSchema = z.object({
  licenseId: z.string(),
  isTrainingLicense: z.boolean(),
  product: z.string().nullable(),
  customerId: z.string().nullable(),
  customerName: z.string().nullable(),
  isDeactivated: z.boolean(),
  isDeleted: z.boolean(),
  updatedAt: z.string(),
  matchedSystemIds: z.array(z.string()),
});

export type LicenseViewerRow = z.infer<typeof LicenseViewerRowSchema>;

export const ListLicenseViewerResponseSchema = z.object({
  licenses: z.array(LicenseViewerRowSchema),
  totalCount: z.number(),
  page: z.number(),
  pageSize: z.number(),
});

export type ListLicenseViewerResponse = z.infer<typeof ListLicenseViewerResponseSchema>;

export const licenseViewerSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(25),
  searchTerm: z.string().optional(),
  product: z.string().optional(),
  isTrainingLicense: z.boolean().optional(),
  status: z.nativeEnum(LicenseStatus).optional(),
});

export type ListLicenseViewerQuery = z.infer<typeof licenseViewerSearchSchema>;
